import React from 'react';
import { Link } from 'react-router-dom';
import './SuccessStoriesPage.css';

// --- IMPORTACIÓN DE IMÁGENES REALES ---
// Subimos un nivel (..) para salir de 'pages', entramos a 'components/fotos_testimonios'
import samuelImg from '../components/fotos_testimonios/samuel.jpg';
import sysavaneImg from '../components/fotos_testimonios/sysavane.jpg';
import josueImg from '../components/fotos_testimonios/josue.jpg';
import isaacImg from '../components/fotos_testimonios/isaac.jpeg';
import gilbertoImg from '../components/fotos_testimonios/gilberto.jpg';

const SuccessStoriesPage = () => {
  
  // Datos reales de los alumnos
  const stories = [
    {
      id: 1,
      name: "Samuel Cristobal",
      role: "Estudiante (10mo semestre) - Perú",
      // Dividimos el texto para que encaje en el diseño: Cita principal vs Detalle
      quote: "A lo largo de los cursos y webinars de The Bull Miner pude fortalecer mis bases en estimación y modelamiento geológico, pero también aprender nuevas metodologías y enfoques que antes no manejaba.",
      detail: "Estos espacios me ayudaron a entender mejor el proceso completo, desde la interpretación hasta la estimación, y a desarrollar un criterio más técnico y aplicado. Siento que ahora tengo una visión más clara y segura para abordar proyectos rigurosos.",
      img: samuelImg,
      link: "/courses/1" // Link sugerido
    },
    {
      id: 2,
      name: "Sy Savané Syndou",
      role: "Especialista SIG y Gestor de BD - Costa de Marfil",
      quote: "He participado en la formación “Las 12 etapas de la estimación de recursos”. Esta formación me ha permitido comprender de manera clara el proceso, desde la preparación de datos hasta la clasificación.",
      detail: "Actualmente me desempeño como Asistente Técnico en el sector minero. Esta capacitación representa un aporte importante para mi desarrollo profesional y para la aplicación práctica en proyectos reales. Agradezco a Grupo The Bull Miner por la calidad.",
      img: sysavaneImg,
      link: "/courses/2"
    },
    {
      id: 3,
      name: "Josué Jazziel Salgado",
      role: "Geólogo - México",
      quote: "Las clases de Leapfrog del Inge Demian me han sido de gran ayuda para aprender cómo generar un modelo geológico paso a paso desde cero. Su forma de explicar es muy clara y fácil de entender.",
      detail: "Las clases son muy didácticas al compartir los datos y permitirnos seguir el ejercicio junto con él. Es de mucha ayuda para aquellos que estamos interesados en aprender este increíble software, que ya es muy utilizado en la industria.",
      img: josueImg,
      link: "/courses/2"
    },
    {
      id: 4,
      name: "Isaac Reyes",
      role: "Geólogo - Argentina",
      quote: "El Ing. Demian logra plasmar de manera clara y didáctica procesos que llevan años de aprender, lo cual surge de su experiencia.",
      detail: "Esta característica se puede ver en sus clases al momento de explicar el paso a paso, no solo para la estimación de recursos sino también para el modelado geológico. Claridad y experiencia pueden verse en sus clases.",
      img: isaacImg,
      link: "/courses/2"
    },
    {
      id: 5,
      name: "Gilberto Vega",
      role: "Mestrando em Recursos Minerais - Angola",
      quote: "Os cursos leccionados, especialmente de estimação de reservas, constituem uma ferramenta excepcional para responder os problemas de modelação geológica.",
      detail: "Una herramienta excepcional para responder a los problemas de modelado geológico en la industria.",
      img: gilbertoImg,
      link: "/courses/1"
    }
  ];

  // Función para alternar los colores de las tarjetas (Oscuro -> Morado -> Azul -> Repetir)
  const getCardClass = (index) => {
    const styles = ['dark-card', 'accent-card-1', 'accent-card-2'];
    return styles[index % styles.length];
  };

  return (
    <div className="stories-container">
      
      {/* 1. HERO SECTION */}
      <header className="stories-hero">
        <h1>Historias de Éxito</h1>
        <div className="hero-underline"></div>
        
        <div className="hero-description">
          <p>
            Los estudiantes de <strong>The Bull Miner</strong> no solo aprenden software; transforman sus carreras.
            Nuestros alumnos pasan a convertirse en <strong>Geólogos de Datos</strong>, líderes en innovación y 
            expertos en automatización en sus propias empresas.
          </p>
          <p>Mira cómo algunos de nuestros alumnos han aplicado lo aprendido:</p>
        </div>
      </header>

      {/* 2. STORIES LIST (Dinámico) */}
      <section className="stories-list">
        
        {stories.map((story, index) => (
          <div key={story.id} className={`story-card ${getCardClass(index)}`}>
            
            {/* Contenido Texto */}
            <div className="story-content">
              <h2>{story.name}</h2>
              <p className="story-role">{story.role}</p>
              
              <div className="story-quote">
                "{story.quote}"
              </div>
              
              <p className="story-detail">
                {story.detail}
              </p>
              
              <Link to={story.link} className="read-story-link">VER CURSO RELACIONADO →</Link>
            </div>
            
            {/* Imagen */}
            <div className="story-image">
              <img src={story.img} alt={story.name} />
            </div>
          </div>
        ))}

      </section>

      {/* 3. CTA BOTTOM */}
      <section className="stories-cta">
        <div className="cta-text-side">
          <h2>¿Listo para comenzar tu propia historia de éxito?</h2>
          <p>
            Avanza a tu propio ritmo con soporte en vivo, una comunidad útil y talleres temáticos.
          </p>
          
          {/* Enlace ancla a la sección de cursos en el Home */}
          <Link to="/#cursos-pro" className="btn-cta-green">
            VER TODOS LOS CURSOS <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
        
        <div className="cta-img-side">
          <img 
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=800&auto=format&fit=crop" 
            alt="Estudiantes trabajando" 
            style={{ borderRadius: '10px', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}
          />
        </div>
      </section>

    </div>
  );
};

export default SuccessStoriesPage;